import React, { useEffect } from 'react';
import './AccessibilityFeatures.css';

function AccessibilityFeatures() {
  useEffect(() => {
    // Migliora la navigazione da tastiera
    const handleFirstTab = (e) => {
      if (e.key === 'Tab') {
        document.body.classList.add('user-is-tabbing');
      }
    };

    const handleMouseDown = () => {
      document.body.classList.remove('user-is-tabbing');
    };

    window.addEventListener('keydown', handleFirstTab);
    window.addEventListener('mousedown', handleMouseDown);

    return () => {
      window.removeEventListener('keydown', handleFirstTab);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return (
    <>
      {/* Screen Reader Only - info tema */}
      <div className="sr-only" aria-live="polite" id="theme-announcement"></div>
    </>
  );
}

export default AccessibilityFeatures;
